// src/helpers/rutaUsuarios.js (FRONTEND)
import axios from "axios";
import qs from "qs";

// Base por defecto (HTTPS) + variable de entorno opcional
const DEFAULT_BASE = "https://backdanlu.eu-4.evennode.com";
let BASE_URL = process.env.REACT_APP_API_BASE || DEFAULT_BASE;

// Guardia: si la app corre en HTTPS, jamás usar http en la API
if (typeof window !== "undefined" &&
    window.location.protocol === "https:" &&
    BASE_URL.startsWith("http://")) {
  console.warn("[rutaUsuarios] Corrigiendo BASE_URL insegura:", BASE_URL);
  BASE_URL = BASE_URL.replace("http://", "https://");
}

// Cliente axios centralizado
const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // dejalo si usás cookies; si no, podés quitarlo
});

// 🔐 Login
export const postLogin = async (datos) => {
  try {
    const resp = await api.post("/login", qs.stringify(datos), {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    });
    return { data: resp.data, loading: false };
  } catch (error) {
    return {
      data: error.response?.data || { error: "Error desconocido" },
      loading: false,
    };
  }
};

// 📄 Traer todos los usuarios
export const getUsuarios = async () => {
  try {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("jwt") ||
      "";

    const resp = await api.get("/usuarios", {
      headers: {
        // si tu backend acepta 'token' y/o 'Authorization':
        token,
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      data: error.response?.data || { error: "Error desconocido" },
      loading: false,
    };
  }
};

// 📌 Traer un usuario por ID
export const getUsuarioId = async (id) => {
  try {
    const resp = await api.get(`/usuarios/${id}`);
    return resp.data;
  } catch (error) {
    return {
      data: error.response?.data || { error: "Error desconocido" },
      loading: false,
    };
  }
};
